<script>  
  import Page from "../../components/Page.svelte";  
  import Saos from 'saos/src/Saos.svelte';
</script>

<Page>  
  <div class="about-section">
    <div class="container">
      <h1>Privacy Policy</h1>
<p>Last updated: May 17, 2022</p>
<p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your
  information when You use the Service and tells You about Your privacy rights and how the law protects
  You.</p>
<h2>Interpretation and Definitions</h2>
<h3>Interpretation</h3>
<p>The words of which the initial letter is capitalized have meanings defined under the following
  conditions. The following definitions shall have the same meaning regardless of whether they appear in
  singular or in plural.</p>
<h3>Definitions</h3>
<p>For the purposes of this Privacy Policy:</p>

  <ul>
  <li>Account means a unique account created for You to access our Service or parts of our Service.</li>
  <li>Affiliate means an entity that controls, is controlled by or is under common control with a party,
    where "control" means ownership of 50% or more of the shares, equity interest or other
    securities entitled to vote for election of directors or other managing authority.</li>
  <li>Application means the software program provided by the Company downloaded by You on any
    electronic device, named DOE Rankings</li>
  <li>Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers
    to DOE Rankings.</li>
  <li>Country refers to: District Of Columbia, United States</li>
  <li>Device means any device that can access the Service such as a computer, a cellphone or a
    digital tablet.</li>
  <li>Personal Data is any information that relates to an identified or identifiable individual.</li>
  <li>Service refers to the Application.</li>
  <li>You means the individual accessing or using the Service, or the company, or other legal entity
    on behalf of which such individual is accessing or using the Service, as applicable.
    Collecting and Using Your Personal Data</li>
</ul>
<h2>Types of Data Collected</h2>
<h3>Personal Data</h3>
<p>While using Our Service, We do not collect personally identifiable information that can be used to
  contact or identify You.</p>
<h3>Links to Other Websites</h3>
<p>Our Service may contain links to other websites that are not operated by Us. If You click on a third
  party link, You will be directed to that third party's site. We strongly advise You to review the Privacy
  Policy of every site You visit.</p>
<p>We have no control over and assume no responsibility for the content, privacy policies or practices of
  any third party sites or services.</p>
<h2>Changes to this Privacy Policy</h2>
<p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting
  the new Privacy Policy on this page.</p>
<p>We will let You know via email and/or a prominent notice on Our Service, prior to the change
  becoming effective and update the "Last updated" date at the top of this Privacy Policy.</p>
<p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy
  Policy are effective when they are posted on this page.</p>
<h2>Contact Us</h2>
<p>If you have any questions about this Privacy Policy, You can contact us:</p>
<ul><li>By email: info@dogsofelon.io</li></ul>
    </div>
  </div>                      
</Page>


<style>
@keyframes -global-fadeInLeft {
  0% {
      opacity: 0;
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
  }
  to {
      opacity: 1;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
  }
}
@keyframes -global-fadeInRight {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }
    to {
        opacity: 1;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}
@-webkit-keyframes -global-zoomIn {
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
        opacity: 1;
    }
}
.avatar {
  width: 153px;
height: 157px;
border-radius: 50%;
object-fit: cover;
}
.about-section{
  padding: 80px 0 130px 0;
}
.common_home_section .white_normal_p{
  color: #fff;
  font-style: normal;
}
.statement_section{
  padding: 150px 0;
}
.tokenomics_section{
  padding: 150px 0;
}
.tokenomics_data p{
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-style: normal;
  margin-bottom: 8px;
}
.team_section{
  padding: 150px 0 15px 0;
}
.team_section h2{
  font-size: 48px;
  font-weight: 600;
  color: #93CDBF;
  margin-bottom: 50px;
}
.team_card_outer{
  display: flex;
  flex-wrap: wrap;
  
}
.team_card_outer{
  margin-left: -9px;
  margin-right: -9px;
}
.team_card_content{  
  width: 25%;
  padding-right: 9px;
  padding-left: 9px;
  margin-bottom: 30px;
}
.team_card{
  text-align: center;
  background-color: #1E2031;
  padding: 60px 0 50px 0;
}
.team_card p{
  font-size: 27px;
  font-weight: 600;
  margin: 36px 0 45px 0;
  color: #fff;
}
.team_card span{
  color: #A1A1A1;
  font-size: 17px;
  font-weight: 300;
}
.card_social_link{
  margin-top: 60px;
}
.card_social_link a:nth-child(2){
  margin-left: 40px;
}
.card_social_link a {
  color: #1E2031;
}    
.card_social_link a img{
  height: 55px;
}
.card_social_link a img:last-child{
  display:none;
}
.card_social_link a:hover img:last-child{
  display:inline-block;
}
.card_social_link a:hover img:first-child{
  display:none;
}
.mission_vision{
  background-color: #1E2031;
  padding: 50px;
  height: 100%;
}
@media (max-width:1300px){
  .team_section h2{
    font-size: 36px;
    margin-bottom: 40px;
  }
}
@media (max-width:1200px){
  .about-section{
    padding: 70px 0;
  }
  .statement_section{
    padding: 80px 0;
  }
  .tokenomics_section{
    padding: 80px 0;
  }
  .team_section{
    padding: 80px 0 15px 0;
  }
  .team_card_content{
    width: 33.33%;
  }
  .mission_vision{   
    padding: 30px;    
  }
}
@media (max-width:992px){
  .about-section{
    padding: 50px 0;
  }
  .statement_section{
    padding: 50px 0;
  }
  .tokenomics_section{
    padding: 50px 0;
  }
  .team_section{
    padding: 50px 0 15px 0;
  }  
  .team_card{
    padding: 45px 0 40px 0;
  }
  .team_card>img{
    height: 120px;
  }
  .team_card p{
    font-size: 24px;
    margin: 30px 0;
  }
  .card_social_link{
    margin-top: 40px;
  }
  .card_social_link a img{
    height: 42px;
  }
}
@media (max-width:768px){
  .team_card_content{
    width: 50%;
  }
  .team_section h2{
    font-size: 30px;
    margin-bottom: 25px;
  }
}
@media (max-width:576px){
  .about-section{
    padding: 30px 0;
  }
  .statement_section{
    padding: 30px 0;
  }
  .tokenomics_section{
    padding: 30px 0;
  }
  .team_section{
    padding: 30px 0 15px 0;
  }  
  .team_card_content{
    width: 100%;
  }
  .avatar {
    height: 120px;
    width: 120px;
  }
  .team_card p {
    font-size: 22px;
    margin: 20px 0;
  }
  .card_social_link {
    margin-top: 25px;
  }
  .team_card_content{
    margin-bottom: 20px;
  }
  .mission_vision{   
    padding: 15px;    
  }
}
</style>
